import React from "react";

import { Slot, type Slottable } from "~/components/slot";
import { cx } from "~/tools/class-variance";

import styles from "./_divider.module.css";

export interface DividerProps extends Slottable, React.HTMLAttributes<HTMLElement> {}

export const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
	({ asChild = false, className, ...props }, ref) => {
		const Content = asChild ? Slot : "div";

		return <Content className={cx(styles.divider, className)} ref={ref} {...props} />;
	},
);

if (import.meta.env.DEV) {
	Divider.displayName = "Divider";
}
